import Box, { BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const StyledTextBox = styled(Box)<BoxProps>({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  wordBreak: 'break-word',
  minWidth: 0,
});
